exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".recording[data-v-7e985a13]{width:20px;height:20px;margin:auto}\n", ""]);
